import "../Ingreso/Ingreso.css"
import "./Confirmacion.css"
import { useNavigate } from "react-router-dom";

const Confirmacion = (props) => {

    const navigate = useNavigate();

    function logout() {
        localStorage.setItem("login", false);
        localStorage.setItem("loginStatus", "Sesión cerrada exitosamente");
        //navigate("/");
        window.location.href = "https://cootransfusa.com/mantenimiento/"
    }

    const regreso = () => {
        const data = {
            sesion: true,
            formato: false,
            ingreso: false
        }
        props.handleDataReceived(props.stringify(data))
    }

    return(
        <div className="confirmacion">
            <h1 className="conf_title">Revisión registrada exitosamente</h1>
            <button onClick={regreso} className="button_back conf_button_left"><i class="fa-solid fa-rotate-left" style={{ color: "#ffffff", marginRight: "10px" }}></i>Volver al inicio</button>
            <button type="button" onClick={logout} className="button_logout conf_button_right">Cerrar Sesión<i class="fa-solid fa-right-from-bracket" style={{ color: "#ffffff", marginLeft: "10px" }}></i></button>
        </div>
    )
}

export default Confirmacion